import {
  Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewEncapsulation, TemplateRef,
  HostBinding, ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, SimpleChanges, SimpleChange, ViewChild
} from '@angular/core';
import {ModalEditFormComponent} from '../../../modal-edit-form';
import {DataManager} from '../../base';
import { Subscription, interval, timer} from 'rxjs';
import {ContextMenuComponent, MenuEventArgs} from '../../../context-menu';
import {DataTableComponent, Row} from '../../../ng-data-table';
import {EventHelper, ColumnModelGenerator, DataFilter} from '../../../ng-data-table/base';
import {MenuItem} from '../../../common';
import { mainAndSubHeaders } from 'src/app/shared/columns';
import { PageEvent } from 'lib/pagination';

@Component({
  selector: 'app-crud-table',
  templateUrl: './crud-table.component.html',
  styleUrls: [
    'crud-table.component.css',
    '../../../styles/icons.css',
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CrudTableComponent implements OnChanges, OnDestroy {

  @Input() popupOrNot: boolean;
  @Input() dataManager: DataManager;
  @Input() rsltType: string;
  @Input() selectedSubResults: any;

  @Input() AutoRefreshInfo: any = {};

  @Input() requestID: string;

  @Input() boolMainHeader: boolean;
  @Output() rowsChanged: EventEmitter<boolean> = new EventEmitter();
  @Output() downloaded = new EventEmitter();
  @Output() rowDeleted = new EventEmitter();
  @Output() calleventErrorEvents = new EventEmitter();
  @Output() connDropEvents = new EventEmitter();

  @ViewChild('modalEditForm', {static: false}) modalEditForm: ModalEditFormComponent;
  @ViewChild('rowMenu', {static: true}) rowMenu: ContextMenuComponent;
  @ViewChild(DataTableComponent, {static: true}) dt: DataTableComponent;
  @ViewChild('rowActionTemplate', {static: true}) rowActionTemplate: TemplateRef<any>;
  @ViewChild('headerActionTemplate', { static: true }) headerActionTemplate: TemplateRef<any>;
  @ViewChild('onlyDelActionTemplate', { static: true }) onlyDelActionTemplate: TemplateRef<any>;//susheel - Delete button at the end of each config screen table row

  @HostBinding('class.datatable') cssClass = true;

  actionMenu: MenuItem[] = [];
  private subscriptions: Subscription[] = [];

  constructor(private cd: ChangeDetectorRef) { }
  //ngOnChanges(changes: SimpleChanges) {
  //  const dM: SimpleChange = changes.dataManager;
  //  this.dataManager = dM.currentValue;
  //}

  //ngOnChanges(changes: SimpleChanges) {
  //  //const currentItem: SimpleChange = changes.dataManager;
  //  //this.dataManager = currentItem.currentValue;

  //  for (const propName in changes) {
  //    if (changes.hasOwnProperty(propName)) {
  //      switch (propName) {
  //        case 'selectedSubResults': {
  //          if (changes.currentValue != undefined)
  //            this.selectedSubResults = changes.currentValue;
  //          break;
  //        }
  //      }
  //    }
  //  }
  //}

  interval;
  async ngOnChanges(changes: SimpleChanges) {
    if (this.dataManager) {
      if (this.boolMainHeader) {
        let headersList = mainAndSubHeaders(this.rsltType, this.selectedSubResults);

        this.items = headersList.internal;
        this.LeftStartIndex = headersList.LeftStartIndex;
        this.LeftEndIndex = headersList.LeftEndIndex;
        this.RightStartIndex = headersList.RightStartIndex;
        this.RightEndIndex = headersList.RightEndIndex;
      }

      const actionColumn = this.dataManager.columns.find(x => x.name === ColumnModelGenerator.actionColumn.name);
      if (actionColumn) {
        actionColumn.cellTemplate = this.rowActionTemplate;
        actionColumn.headerCellTemplate = this.headerActionTemplate;
      }
      const delColumn = this.dataManager.columns.find(x => x.name === ColumnModelGenerator.delColumn.name);
      if (delColumn) {
        delColumn.cellTemplate = this.onlyDelActionTemplate;
      }
      this.initRowMenu();
      if (this.dataManager.settings.initLoad) {
        await this.dataManager.loadItems();//.catch(() => this.cd.markForCheck());
        //console.log(this.dataManager.rows)
        //console.log('onInitLoad' + new Date())
        //this.dataManager.settings.initLoad = false;
      }

      if (this.AutoRefreshInfo) {
        //https://stackoverflow.com/questions/45293635/how-to-use-clearinterval-in-angular-4
        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);
            this.dataManager.loadItems();//.catch(() => this.cd.markForCheck());
          }, this.AutoRefreshInfo.AutoRefSelected);
        }
      }
      //const subInterval = interval(this.AutoRefreshInfo.AutoRefSelected)
      //  .subscribe(x => {
      //    if (this.AutoRefreshInfo.AutoRefStop) {
      //      return;
      //    }
      //    console.log(new Date());
      //    console.log(this.AutoRefreshInfo.AutoRefSelected)
      //    this.dataManager.loadItems().catch(() => this.cd.markForCheck());
      //});
      ////if (this.AutoRefreshInfo.AutoRefStop && subInterval)
      ////  subInterval.unsubscribe();

      const subFilter = this.dataManager.events.filterSource$.subscribe(() => {
        this.onFilter();
      });
      //const subFilterClear = this.dataManager.events.filterClearSource$.subscribe(() => {
      //  this.onFilterClear();
      //});
      const subSort = this.dataManager.events.sortSource$.subscribe(() => {
        this.onSort();
      });
      const subPage = this.dataManager.events.pageSource$.subscribe(() => {
        this.onPageChanged();
      });
      //const subRows = this.dataManager.events.rowsChanged$.subscribe(() => {
      //  console.log('subRows')
      //  this.rowsChanged.emit(true);
      //});
      const subScroll = this.dataManager.events.scrollSource$.subscribe(() => {
        this.rowMenu.hide();
        requestAnimationFrame(() => this.cd.detectChanges());
      });

      //this.subscriptions.push(subInterval);
      this.subscriptions.push(subFilter);
      //this.subscriptions.push(subFilterClear);
      this.subscriptions.push(subSort);
      this.subscriptions.push(subPage);
      //this.subscriptions.push(subRows);
      this.subscriptions.push(subScroll);
    }
 }

  ngOnDestroy() {
    //console.log('called')
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  initRowMenu() {
    if (this.dataManager.settings.singleRowView) {
      this.actionMenu.push(
        {
          id: this.dataManager.messages.titleDetailView,
          label: this.dataManager.messages.titleDetailView,
          icon: 'dt-icon dt-icon-rightwards',
          command: (row) => this.viewAction(row),
        }
      );
    }
    if (this.dataManager.settings.crud) {
      this.actionMenu.push(
        {
          id: this.dataManager.messages.titleUpdate,
          label: this.dataManager.messages.titleUpdate,
          icon: 'dt-icon dt-icon-pencil',
          command: (row) => this.updateAction(row),
        },
        {
          id: this.dataManager.messages.refresh,
          label: this.dataManager.messages.refresh,
          icon: 'dt-icon dt-icon-reload',
          command: (row) => this.dataManager.refreshRow(row),
        },
        {
          id: this.dataManager.messages.revertChanges,
          label: this.dataManager.messages.revertChanges,
          icon: 'dt-icon dt-icon-return',
          command: (row) => this.dataManager.revertRowChanges(row),
          disabled: true,
        },
        {
          id: this.dataManager.messages.save,
          label: this.dataManager.messages.save,
          icon: 'dt-icon dt-icon-ok',
          command: (row) => this.dataManager.update(row),
          disabled: true,
        },
        {
          id: this.dataManager.messages.delete,
          label: this.dataManager.messages.delete,
          icon: 'dt-icon dt-icon-remove',
          command: (row) => confirm('Delete ?') ? this.dataManager.delete(row) : null,
        },
        {
          id: this.dataManager.messages.duplicate,
          label: this.dataManager.messages.duplicate,
          icon: 'dt-icon dt-icon-plus',
          command: (row) => this.duplicateAction(row),
        },
      );
    }
  }

  rowMenuBeforeOpen(row: Row) {
    const rowChanged = this.dataManager.rowChanged(row);
    let menuIndex = this.actionMenu.findIndex(x => x.id === this.dataManager.messages.revertChanges);
    if (menuIndex > -1) {
      this.actionMenu[menuIndex].disabled = !rowChanged;
    }
    menuIndex = this.actionMenu.findIndex(x => x.id === this.dataManager.messages.save);
    if (menuIndex > -1) {
      const rowIsValid = this.dataManager.rowIsValid(row);
      this.actionMenu[menuIndex].disabled = !rowChanged || !rowIsValid;
    }
  }

  onRowMenuClick(event: Event, row: Row) {
    const {left, top} = EventHelper.getRowPosition(event, this.dataManager.settings.virtualScroll);
    this.rowMenuBeforeOpen(row);
    this.rowMenu.show({originalEvent: event, data: row, left, top} as MenuEventArgs);
  }
  onRowDelClick(event: Event, row: Row) {
    //confirm('Delete ?') ? this.dataManager.deleteInternally(row) : null;
    this.rowDeleted.emit(row);
  }

  createAction() {
    this.dataManager.item = new Row({});
    this.modalEditForm.isNewItem = true;
    this.modalEditForm.detailView = false;
    this.modalEditForm.open();
  }

  viewAction(row: Row) {
    this.dataManager.item = row;
    this.modalEditForm.isNewItem = false;
    this.modalEditForm.detailView = true;
    this.modalEditForm.open();
  }

  updateAction(row: Row) {
    this.dataManager.item = row;
    this.modalEditForm.isNewItem = false;
    this.modalEditForm.detailView = false;
    this.modalEditForm.open();
  }

  duplicateAction(row: Row) {
    this.dataManager.item = row.clone();
    this.modalEditForm.isNewItem = true;
    this.modalEditForm.detailView = false;
    this.modalEditForm.open();
  }

  onPageChanged() {
    this.dataManager.loadItems();
    //console.log('onPageCh')
  }
  onPerPageChanged(event: PageEvent): void {
    //console.log('Records per page')
    event.perPageOrCurrPageChanged = true;
    this.dt.onPageChanged(event);
  }
  onDownloaded(type): void {
    this.downloaded.emit(type);
  }

  onFilterCEErrorEvents(getErrorEvent): void {
    this.calleventErrorEvents.emit(getErrorEvent);
  }
  onFilterConnDrops(getErrorEvent): void {
    this.connDropEvents.emit(getErrorEvent);
  }

  onFilter() {
    this.dataManager.pager.current = 1;
    if (this.dataManager.settings.virtualScroll) {
      this.dt.body.scroller.setOffsetY(0);
      this.dataManager.pagerCache = {};
      this.dataManager.clear();
    }
    this.dataManager.loadItems();
    //console.log(new Date())
    //console.log('onFilter')
  }
  //onFilterClear() {
  //  this.clearAllFilters();
  //}

  onSort() {
    if (this.dataManager.settings.virtualScroll) {
      this.dt.body.scroller.setOffsetY(0);
      this.dataManager.pager.current = 1;
      this.dataManager.pagerCache = {};
      this.dataManager.clear();
    }
    this.dataManager.loadItems();
    //console.log('onSort')
  }

  onLoadedForm() {
    this.cd.markForCheck();
  }

  clearAllFilters() {
    //console.log(new Date())
    this.dataManager.service.clearAllFilters();
    this.dataManager.dataFilter.clear();
    this.dataManager.events.onFilter();
    this.dataManager.events.onSort();
  }


  items: any[];
  LeftStartIndex: number;
  LeftEndIndex: number;
  RightStartIndex: number;
  RightEndIndex: number;

  getWidth(from: number, to: number) {
    let width = 0;
    //console.log(from + ":" + to);
    for (let index = from; index < to; index++) {
      //console.log(index + ":" + this.dataManager.columns[index].title);
      width += this.dataManager.columns[index].width;
    }
    return width;
  }

  translate3d() {
    return `translate3d(${this.dataManager.dimensions.offsetX * -1}px, 0, 0)`;
  }

  translate3dCell() {
    return `translate3d(${this.dataManager.dimensions.offsetX}px, 0, 0)`;
  }
}
